// extracted by mini-css-extract-plugin
export default {"info-message-box__container":"info-message-box__container_m8nLazz_"};